import {defineCustomElement, h, getCurrentInstance, createApp, defineAsyncComponent} from 'vue';
import Icon from '@/plugins/icon'
import Directive from '@/plugins/directive'
import PrimeVue from 'primevue/config';
import Menu from "primevue/menu";
import Tooltip from "primevue/tooltip";
import Button from "primevue/button";
import InputNumber from "primevue/inputnumber";
import Dropdown from "primevue/dropdown";
import SelectButton from "primevue/selectbutton";
import VueTimepicker from 'vue3-timepicker'
import ToggleButton from "primevue/togglebutton";
import InputSwitch from "primevue/inputswitch";
import InputText from "primevue/inputtext";
import InputGroup from "primevue/inputgroup";
import InputGroupAddon from "primevue/inputgroupaddon";
import Checkbox from "primevue/checkbox";
import Textarea from "primevue/textarea";
import AutoComplete from "primevue/autocomplete";
import Toolbar from "primevue/toolbar";
import OverlayPanel from "primevue/overlaypanel";
import ColorPicker from "primevue/colorpicker";
import Inplace from "primevue/inplace";
import Dialog from "primevue/dialog";
import Menubar from "primevue/menubar";
import Avatar from "primevue/avatar";
import Sidebar from "primevue/sidebar";
import Slider from "primevue/slider";
import {createPinia} from "pinia";
import RadioButton from 'primevue/radiobutton'
import Divider from 'primevue/divider'
import FileUpload from "primevue/fileupload";
import Badge from "primevue/badge";
import Paginator from "primevue/paginator";
import Accordion from "primevue/accordion";
import AccordionTab from "primevue/accordiontab";
import Skeleton from "primevue/skeleton";
import ProgressBar from "primevue/progressbar";
import Toast from "primevue/toast";
import Image from "primevue/image";
import TabView from "primevue/tabview"
import TabPanel from "primevue/tabpanel"
import Calendar from "primevue/calendar"

const plugins = [PrimeVue, Icon, Directive];
const Canvas = defineAsyncComponent(() =>
    import('./views/Viewer/Canvas/index.vue')
)

const registerComponents = (app: any) => {
    const components = [
        Button,
        InputNumber,
        Dropdown,
        SelectButton,
        ToggleButton,
        InputSwitch,
        InputText,
        InputGroup,
        InputGroupAddon,
        Checkbox,
        Textarea,
        AutoComplete,
        Toolbar,
        OverlayPanel,
        ColorPicker,
        Inplace,
        Dialog,
        Menubar,
        Avatar,
        Sidebar,
        Slider,
        RadioButton,
        Divider,
        FileUpload,
        Badge,
        Paginator,
        Accordion,
        AccordionTab,
        Skeleton,
        ProgressBar,
        Toast,
        Image,
        TabView,
        TabPanel,
        Calendar,
        VueTimepicker
    ];

    components.forEach((component) => app.component(component.name, component));
}

const getSlideStyle = () => {
    let css = window['templateCss']
    if (!css) {
        return ""
    }

    const start = css.indexOf("/* Start Slide Editor CSS")
    if (start > -1) {
        css = css.substring(start)
    }

    const end = css.indexOf("/* End Slide Editor CSS")
    if (end > -1) {
        css = css.substring(0, end)
    }

    return css
}

const pinia = createPinia()

export const slideWidget = defineCustomElement({
    props: Canvas.props,
    setup(props) {
        const app = createApp(Canvas);
        registerComponents(app)

        plugins.forEach(plugin => app.use(plugin));
        app.component('PrimeMenu', Menu)

        app.directive('tooltip', Tooltip);
        app.use(pinia)

        const inst = getCurrentInstance();
        if (inst === null) return;
        Object.assign(inst.appContext, app._context);
        Object.assign(inst.appContext.provides, app._context.provides);

        return () => h(Canvas, props)
    },
    styles: [getSlideStyle()]
});

export const slideWidgetNoShadow = defineCustomElement({
    props: Canvas.props,
    shadowRoot: false,
    setup(props) {
        const app = createApp(Canvas);
        registerComponents(app)

        plugins.forEach(plugin => app.use(plugin));
        app.component('PrimeMenu', Menu)

        app.directive('tooltip', Tooltip);
        app.use(pinia)

        const inst = getCurrentInstance();
        if (inst === null) return;
        Object.assign(inst.appContext, app._context);
        Object.assign(inst.appContext.provides, app._context.provides);

        return () => h(Canvas, props)
    },
    styles: [getSlideStyle()]
});


const stylesheets = [
    `${import.meta.env.VITE_APP_ENV_SERVER}/v2/css/theme.css`,
    `${import.meta.env.VITE_APP_ENV_SERVER}/v2/css/primeicons/primeicons.css`
];

stylesheets.forEach(href => {
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = href;
    document.head.appendChild(link);
});

const style = document.createElement('style');
style.textContent = `
  
  
.p-autocomplete-items li {
    padding: 0.5rem 0.75rem;
}

.p-autocomplete-panel .p-autocomplete-items {
    padding: 0.5rem 0;
}


.p-autocomplete-panel .p-autocomplete-items .p-autocomplete-item {
    margin: 0;
    padding: 0.5rem 1rem;
    border: 0 none;
    color: #495057;
    background: transparent;
    transition: box-shadow 0.2s;
    border-radius: 0;
  }

  .p-autocomplete-panel .p-autocomplete-items .p-autocomplete-item.p-highlight {
    color: #495057;
    background: #E3F2FD;
  }
  .p-autocomplete-panel .p-autocomplete-items .p-autocomplete-item.p-highlight.p-focus {
    background: rgba(33, 150, 243, 0.24);
  }
  .p-autocomplete-panel .p-autocomplete-items .p-autocomplete-item:not(.p-highlight):not(.p-disabled).p-focus {
    color: #495057;
    background: #e9ecef;
  }

.p-dropdown-panel .p-dropdown-items .p-dropdown-item {
    margin: 0;
    padding: 0.5rem 1rem !important;
    border: 0 none;
    color: #495057;
    background: transparent;
    transition: box-shadow 0.2s;
    border-radius: 0;
}

  .p-dropdown-panel .p-dropdown-items .p-dropdown-item.p-highlight {
    color: #495057;
    background: #E3F2FD;
  }
  .p-dropdown-panel .p-dropdown-items .p-dropdown-item.p-highlight.p-focus {
    background: rgba(33, 150, 243, 0.24);
  }
  .p-dropdown-panel .p-dropdown-items .p-dropdown-item:not(.p-highlight):not(.p-disabled).p-focus {
    color: #495057;
    background: #e9ecef;
  }



  .p-overlaypanel {
    margin-top: 10px;
  }

  .p-overlaypanel-flipped {
    margin-top: -10px;
    margin-bottom: 10px;
  }

  .p-overlaypanel-close {
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    position: relative;
  }

  /* Animation */
  .p-overlaypanel-enter-from {
    opacity: 0;
    transform: scaleY(0.8);
  }

  .p-overlaypanel-leave-to {
    opacity: 0;
  }

  .p-overlaypanel-enter-active {
    transition: transform 0.12s cubic-bezier(0, 0, 0.2, 1), opacity 0.12s cubic-bezier(0, 0, 0.2, 1);
  }

  .p-overlaypanel-leave-active {
    transition: opacity 0.1s linear;
  }

  .p-overlaypanel:after,
.p-overlaypanel:before {
    bottom: 100%;
    left: calc(var(--overlayArrowLeft, 0) + 1.25rem);
    content: " ";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
  }

  .p-overlaypanel:after {
    border-width: 8px;
    margin-left: -8px;
  }

  .p-overlaypanel:before {
    border-width: 10px;
    margin-left: -10px;
  }

  .p-overlaypanel-flipped:after,
.p-overlaypanel-flipped:before {
    bottom: auto;
    top: 100%;
  }

  .p-overlaypanel.p-overlaypanel-flipped:after {
    border-bottom-color: transparent;
  }

  .p-overlaypanel.p-overlaypanel-flipped:before {
    border-bottom-color: transparent;
  }

  .p-overlaypanel {
    background: #ffffff;
    color: #495057;
    border: 0 none;
    border-radius: 3px;
    box-shadow: 0px 11px 15px -7px rgba(0, 0, 0, 0.2), 0px 24px 38px 3px rgba(0, 0, 0, 0.14), 0px 9px 46px 8px rgba(0, 0, 0, 0.12);
  }
  .p-overlaypanel .p-overlaypanel-content {
    padding: 1rem;
  }
  .p-overlaypanel .p-overlaypanel-close {
    background: #2196F3;
    color: #ffffff;
    width: 2rem;
    height: 2rem;
    transition: background-color 0.2s, color 0.2s, box-shadow 0.2s;
    border-radius: 50%;
    position: absolute;
    top: -1rem;
    right: -1rem;
  }
  .p-overlaypanel .p-overlaypanel-close:enabled:hover {
    background: #0d89ec;
    color: #ffffff;
  }
  .p-overlaypanel:after {
    border-style: solid;
    border-color: rgba(255, 255, 255, 0);
    border-bottom-color: #ffffff;
  }
  .p-overlaypanel:before {
    border-style: solid;
    border-color: rgba(255, 255, 255, 0);
    border-bottom-color: #f2f2f2;
  }
  .p-overlaypanel.p-overlaypanel-flipped:after {
    border-top-color: #ffffff;
  }
  .p-overlaypanel.p-overlaypanel-flipped:before {
    border-top-color: #ffffff;
  }
  
  
`;
document.head.appendChild(style);
